module.exports = "<label [class]=\"'switch ' + Style\">\r\n    <input [id]=\"name\" [checked]=\"inputValue\" (click)=\"changeStatus()\" type=\"checkbox\" [name]=\"name\" />\r\n    <span></span>\r\n</label>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/customeCheckbox/customeCheckbox.component.html
// module id = ../../../../../app/shared/components/customeCheckbox/customeCheckbox.component.html
// module chunks = main